<template>
  <div class="fluid-xs leading-tightest first-letter:uppercase">
    <i18n-t v-if="author && topic" keypath="knowledge.publishedByIn">
      <template #author>
        <nuxt-link v-if="author.uri" :to="$localeRootPath(author.uri)" class="font-medium">
          {{ author.title }}
        </nuxt-link>
        <strong v-else class="font-medium">{{ author.title }}</strong>
      </template>
      <template #topic>
        <nuxt-link
          v-if="topic"
          :to="
            topic.uri
              ? $localeRootPath(topic.uri)
              : { name: `knowledge-index-topic___${$i18n.locale}`, params: { topic: topic.slug } }
          "
          class="font-medium"
        >
          {{ topic.title }}
        </nuxt-link>
      </template>
      <template #at>
        {{ publishedAtFormatted }}
      </template>
    </i18n-t>

    <i18n-t v-else-if="topic" keypath="knowledge.publishedIn">
      <template #topic>
        <nuxt-link
          v-if="topic"
          :to="{
            name: `knowledge-index-topic___${$i18n.locale}`,
            params: { topic: topic.slug },
          }"
          class="font-medium"
        >
          {{ topic.title }}
        </nuxt-link>
      </template>
      <template #at>
        {{ publishedAtFormatted }}
      </template>
    </i18n-t>

    <span v-else>{{ $t('knowledge.published', { at: publishedAtFormatted }) }}</span>

    <span v-if="hasValidUpdates"> - {{ $t('knowledge.modifiedAt', { at: modifiedAtFormatted }) }} </span>
  </div>
</template>

<script>
export default defineNuxtComponent({
  props: {
    author: {
      type: Object,
      default: () => null,
    },
    topic: {
      type: Object,
      default: () => null,
    },
    at: {
      type: String,
      default: () => null,
    },
    modified: {
      type: String,
      default: () => null,
    },
  },

  setup(props) {
    const { formatDate } = useFormatDate();

    const publishedAtFormatted = computed(() => formatDate(new Date(props.at), 'short'));
    const modifiedAtFormatted = computed(() => formatDate(new Date(props.modified), 'short'));

    const hasValidUpdates = computed(() => {
      // make sure to show modified line only if created and modified differ at least by 30 days
      if (!props.at || !props.modified) {
        return false;
      }

      const created = new Date(props.at);
      const updated = new Date(props.modified);

      return updated - created > 30 * 24 * 60 * 60 * 1000;
    });

    return {
      publishedAtFormatted,
      modifiedAtFormatted,
      hasValidUpdates,
    };
  },
});
</script>
